// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"326f0bee","222":"136147f5","295":"3818752f","645":"7c02504c"}[chunkId] + ".chunk.js";
};